import React, { useState, useEffect } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Chart from "react-apexcharts"
import colorArray from "helpers/colorArray"

//? This is for sales
const TopPerformingTrafficSources = (props) => {
	let limit = 20
	let count = 0
	// Need to count traffic and sale sources, traffic should come in the payload
	var [dataArray, sorted] = [{}, []]
	_.forEach(props.payload.sales.current, (v) => {
		if (!v.traffic_source) {
			return
		}
		count++
		if (v.traffic_source in dataArray) {
			dataArray[v.traffic_source]++
		} else {
			dataArray[v.traffic_source] = 1
		}
	})
	_.forEach(props.payload.bustouts.current, (v) => {
		if (!v.traffic_source) {
			return
		}
		count--
		if (v.traffic_source in dataArray) {
			dataArray[v.traffic_source]--
		} else {
			dataArray[v.traffic_source] = -1
		}
	})
	for (var source in dataArray) {
		sorted.push([source, dataArray[source]])
	}
	sorted
		.sort(function (a, b) {
			return a[1] - b[1]
		})
		.reverse()
		.slice(0, limit)
	let f = {}
	_.forEach(sorted, (v,k) => {
		if (v[0] !== "0") {
			let b = _.find(props.payload.public.trafficSources, {
				id: parseInt(v[0]),
			})
			if(b) {
				f[b.name] = v[1]
			}
		}
	})
	let series = [
		{
			name: "Total",
			data: Object.values(f),
		}
	]
	let labels = Object.keys(f)
	let options = {
		chart: {
			type: "bar",
			stacked: true,
			toolbar: {
				show: true,
				tools: {
					download: false,
				},
				export: {
					csv: {
						columnDelimiter: ";",
					},
				},
			},
		},
		plotOptions: {
			bar: {
				horizontal: true,
				borderRadius: 4,
				dataLabels: {
					total: {
						enabled: true,
						formatter: function (val, opt) {
							return val
							//return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
						},
						dataLabels: {
							enabled: true,
						},
						style: {
							fontSize: "10px",
						},
					},
				},
			},
		},
		stroke: {
			width: 1,
			colors: ["#fff"],
		},
		xaxis: {
			categories: labels,
		},
		colors: colorArray,
		fill: {
			opacity: 1,
		},
		dataLabels: {
			enabled: true,
			formatter: function (val, opt) {
				return Math.round((val / count) * 100) + "%"
				//return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
			},
		},
	}
	return (
		<>
			<h3 className="statBox__title">Sales Traffic Sources</h3>
			<p className="text-xs">Based on {count} sales.</p>
			<Chart options={options} series={series} type="bar" />
		</>
	)
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(TopPerformingTrafficSources)
